import update from '@/ajax/front_api/cart/update';
import get from '@/ajax/front_api/cart/get';

/**
 * @module frontAPI/cart
 *
 * @description
 * Ajax-обертки для работы с корзиной
 */

const cart = {
  update,
  get
};

export default cart;
